/**
 * Offer slider
 *
 * Used by offers and events.
 *
 * Refactor in future if their needs really diverge. However, for now, they are
 * very similar and it's easier to keep them in sync if they are in the same
 * file.
 */
var cor_offer_slider = function() {

  const wrappers = document.querySelectorAll('.js-offer-slider-wrapper');
  for (var i = 0; i < wrappers.length; i++) {

    if (wrappers[i].getAttribute('data-init') !== null) {
      continue;
    }
    wrappers[i].setAttribute('data-init', 'true');

    const addArrowEvents = (instance) => {
      els.prev.addEventListener("click", () => instance.prev());
      els.next.addEventListener("click", () => instance.next());
    };

    const maybeDisableArrows = (instance) => {
      const slidesPerView = Math.floor(instance.options.slides.perView);
      const size = instance.slides.length;
      const relativeSlide = instance.track.details.rel;
      els.prev.disabled = relativeSlide === 0;
      els.next.disabled = relativeSlide === size - slidesPerView;
      els.wrapper.classList.toggle('is-arrows-hidden', els.prev.disabled && els.next.disabled);

    };

    const buildDots = (instance) => {
      const slidesPerView = Math.floor(instance.options.slides.perView);
      const numOfDots = els.slides.length - slidesPerView + 1;
      els.dots.innerHTML = "";
      for (let i = 0; i < numOfDots; i++) {
        const dot = document.createElement("button");
        dot.addEventListener("click", () => instance.moveToIdx(i));
        dot.setAttribute("aria-label", 'Siirry kohtaan ' + i);
        els.dots.appendChild(dot);
      }
      els.wrapper.classList.toggle('is-dots-hidden', numOfDots <= 1)
    };

    const setActiveDots = (instance) => {
      const relativeSlide = instance.track.details.rel;
      const dots = els.dots.querySelectorAll("button");
      for (let i = 0; i < dots.length; i++) {
        dots[i].classList.toggle("is-active", relativeSlide === i);
      };
    };

    const setActiveSlides = (instance) => {
      const slidesPerView = Math.floor(instance.options.slides.perView);
      const relativeSlide = instance.track.details.rel;
      for (let i = 0; i < els.slides.length; i++) {
        els.slides[i].classList.toggle(
          "is-active",
          i >= relativeSlide && i < relativeSlide + slidesPerView
        );
      }
    };

    const wrapper = wrappers[i];

    const els = {
			wrapper: wrapper,
			slider: wrapper.querySelector('.js-offer-slider'),
			slides: wrapper.querySelectorAll('.js-offer-slide'),
			prev: wrapper.querySelector('.js-offer-slider-prev'),
			next: wrapper.querySelector('.js-offer-slider-next'),
			dots: wrapper.querySelector('.js-offer-slider-dots'),
		};

    var count = parseInt(els.slider.getAttribute('data-count'));
    let args = {
      breakpoints: {},
      slides: {
        // loop: true,
        spacing: 14,
        perView: 1.075,
      },
			created: function(instance) {
				addArrowEvents(instance);
				buildDots(instance);
				maybeDisableArrows(instance);
				setActiveDots(instance);
				setActiveSlides(instance);
			},
			slideChanged: function(instance) {
				maybeDisableArrows(instance);
				setActiveDots(instance);
				setActiveSlides(instance);
			},
      optionsChanged: function(instance) {
        buildDots(instance);
				maybeDisableArrows(instance);
        setActiveDots(instance);
				setActiveSlides(instance);
      },
			mounted: function() {
				els.wrapper.classList.add("is-ready");
			},
    }
    if (count == 2) {
      args.breakpoints['(min-width: 620px)'] = {
        slides: {
          perView: 2,
          spacing: 16,
        }
      };
    }
    if (count > 2) {
      args.breakpoints['(min-width: 620px)'] = {
        slides: {
          perView: 2.25,
          spacing: 18,
        }
      };
      args.breakpoints['(min-width: 768px)'] = {
        slides: {
          perView: 2.5,
          spacing: 20,
        }
      };
    }
    if (count == 3) {
      args.breakpoints['(min-width: 1024px)'] = {
        slides: {
          perView: 3,
          spacing: 20,
        }
      };
    }
    if (count > 3) {
      args.breakpoints['(min-width: 1024px)'] = {
        slides: {
          perView: 3,
          spacing: 20,
        }
      };
      args.breakpoints['(min-width: 1500px)'] = {
        slides: {
          perView: 4,
          spacing: 20,
        }
      };
    }

    var slider_instance = new KeenSlider(els.slider, args);
    els.wrapper.classList.add("is-ready");
  }

};

document.addEventListener('DOMContentLoaded', cor_offer_slider);
document.addEventListener('GrowthstackABTestReplacementAfter', cor_offer_slider);
